import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC4CxXYaZTHchqFZIPuRVnft71tNdiSgqc",
  authDomain: "elektrokit-12fb0.firebaseapp.com",
  projectId: "elektrokit-12fb0",
  storageBucket: "elektrokit-12fb0.firebasestorage.app",
  messagingSenderId: "893850555664",
  appId: "1:893850555664:web:e9bf21f2c34119100a0195",
  measurementId: "G-4YLQMKN287"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);